import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import React, { useEffect } from 'react';
import { RouteProps, Route, useLocation } from 'react-router-dom';
import { identifyUser, trackPage } from '../../services/analytics';

export interface Props extends RouteProps {
	name: string;
}

const TrackedRoute: React.FC<Props> = props => {
	const { name, ...routeProps } = props;
	const { userFromIdToken: user } = useMemberExperienceAuth();
	const { pathname } = useLocation();

	useEffect(() => {
		identifyUser(user.id, {
			email: user.email,
			employerId: user.employer_uuid,
			firstName: user.firstName,
			lastName: user.lastName,
		});
		trackPage(name, {
			loggedIn: true,
			path: window.location.pathname,
			url: window.location.href,
		});
	}, [name, pathname, user]);

	return <Route {...routeProps} />;
};

export default TrackedRoute;
